import { render, staticRenderFns } from "./LHighwayRoutes.vue?vue&type=template&id=67316b60&"
import script from "./LHighwayRoutes.vue?vue&type=script&lang=js&"
export * from "./LHighwayRoutes.vue?vue&type=script&lang=js&"
import style0 from "./LHighwayRoutes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports